import { IOtpInput, IOtpSignUpRequestInput, IUserOtp, IUserOtpVerify } from "./user-otp.interface";
import { SEND_OTP, VERIFY_OTP } from "./user-otp.mutation";

import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useMutation } from "@apollo/client";
import { userActions } from "../../state/user";
import useWellnessModalStatusStore from
  "../../hooks/redux-hooks/wellness-modal-status-store/wellness-modal-status-store";

export const useOtpSignUp = () => {
  const [requestOTP, { data, loading, error }] = useMutation<{ otpSignUp: IUserOtp }>(SEND_OTP);
  const dispatch = useDispatch();

  const sendOTP = (data: IOtpSignUpRequestInput) => {
    requestOTP({
      variables: {
        data,
      },
    });
  };

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  useEffect(()=>{
    if (data) {
      dispatch(toastMessageActions.setGlobalAlert({ severity: "success", message: "Code was sent" }));
    }
  }, [data]);

  return {
    sendOTP,
    data: data?.otpSignUp,
    loading,
    error,
  };
};

export const useOtpVerify = () => {
  const [validateOTP, { data, loading, error }] = useMutation<{ otpVerify: IUserOtpVerify }>(VERIFY_OTP);
  const { setShowWellnessUpsell } = useWellnessModalStatusStore();

  const dispatch = useDispatch();

  const verifyOTP = (data: IOtpInput) => {
    validateOTP({
      variables: {
        data,
      },
    });
  };

  useEffect(() => {
    if (data) {
      dispatch(userActions.setTokenNew({ ...data.otpVerify, tokenIssuedTime: Math.floor(new Date().getTime()/1000),
        loginTime: Math.floor(new Date().getTime()/1000) }));

      data?.otpVerify?.user?.wellnessModal && setShowWellnessUpsell(data?.otpVerify?.user?.wellnessModal);
    }
  }, [data]);

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (error) {
      dispatch(toastMessageActions.setGlobalAlert({
        severity: "error",
        message: `${error.message}`,
      }));
    }
  }, [error]);

  return {
    verifyOTP,
    data: data?.otpVerify,
    loading,
    error,
  };
};
